import { render, staticRenderFns } from "./CmgAccountModalLegalCopy.vue?vue&type=template&id=4f5ac9ba&scoped=true&lang=pug&"
import script from "./cmg-account-modal-legal-copy.ts?vue&type=script&lang=ts&"
export * from "./cmg-account-modal-legal-copy.ts?vue&type=script&lang=ts&"
import style0 from "./CmgAccountModalLegalCopy.vue?vue&type=style&index=0&id=4f5ac9ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5ac9ba",
  null
  
)

export default component.exports